var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass:
        "tool nav-item dropdown no-sm-border border-right d-block main-user-block w-100 badge-container",
    },
    [
      _c(
        "a",
        {
          staticClass:
            "nav-link dropdown-toggle bg-white h-100 align-items-center d-flex w-100 h-100",
          attrs: {
            href: "#",
            role: "button",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false",
          },
        },
        [
          _c(
            "span",
            {
              staticClass:
                "d-none d-xs-none d-sm-none d-md-flex d-lg-flex d-xl-flex justify-content-between align-items-center w-100 h-100",
            },
            [
              !_vm.isSatAdmin && !_vm.isApi2Convert
                ? [
                    _c(
                      "a",
                      {
                        staticClass:
                          "p-0 m-0 border-right border-bottom h-100 d-flex align-items-center justify-content-center",
                        on: { click: _vm.handleCreditsNav },
                      },
                      [
                        _vm.isImg2Go || _vm.isCreditsInAllSatsEnabled
                          ? _c(
                              "div",
                              {
                                staticClass: "user-badge",
                                class: _vm.userBadgeBg,
                                on: {
                                  mouseover: function ($event) {
                                    return _vm.handleHideDropDown($event)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "w-100" }, [
                                  _c(
                                    "div",
                                    { staticClass: "user-credits" },
                                    [
                                      _vm._v(_vm._s(this.availableCredit)),
                                      _c("CoinSVG"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.isUserRegistered
                                    ? _c(
                                        "span",
                                        { staticClass: "text-uppercase" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("trans")("FREE TRIAL")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isUserPremium
                                    ? _c(
                                        "span",
                                        { staticClass: "text-uppercase" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("trans")(_vm.userProduct)
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isUserEducational
                                    ? _c(
                                        "span",
                                        { staticClass: "text-uppercase" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm._f("trans")("EDUCATION"))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "bg-white h-100 user-icon" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "24",
                                          height: "28",
                                          viewBox: "0 0 24 28",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M23.08 22.4039C22.4918 20.9114 21.6381 19.5557 20.5666 18.4124C19.4983 17.2657 18.2328 16.3515 16.84 15.7201C16.8275 15.7135 16.815 15.7101 16.8026 15.7034C18.7454 14.2003 20.0083 11.752 20.0083 8.98958C20.0083 4.41347 16.5469 0.705811 12.2746 0.705811C8.00227 0.705811 4.54078 4.41347 4.54078 8.98958C4.54078 11.752 5.80376 14.2003 7.74656 15.7068C7.73408 15.7135 7.72161 15.7168 7.70914 15.7235C6.31207 16.3548 5.05844 17.26 3.98258 18.4157C2.91204 19.56 2.0585 20.9154 1.4691 22.4073C0.890067 23.8678 0.577784 25.4337 0.54915 27.0201C0.548318 27.0558 0.554156 27.0913 0.56632 27.1245C0.578484 27.1577 0.596729 27.1879 0.619978 27.2134C0.643227 27.239 0.671012 27.2592 0.701693 27.2731C0.732375 27.2869 0.765334 27.2941 0.798627 27.294H2.6697C2.80692 27.294 2.91606 27.1771 2.91918 27.0335C2.98155 24.4548 3.94827 22.0399 5.65719 20.2094C7.42536 18.3155 9.77356 17.2734 12.2746 17.2734C14.7756 17.2734 17.1238 18.3155 18.8919 20.2094C20.6009 22.0399 21.5676 24.4548 21.6299 27.0335C21.6331 27.1805 21.7422 27.294 21.8794 27.294H23.7505C23.7838 27.2941 23.8168 27.2869 23.8474 27.2731C23.8781 27.2592 23.9059 27.239 23.9291 27.2134C23.9524 27.1879 23.9706 27.1577 23.9828 27.1245C23.995 27.0913 24.0008 27.0558 24 27.0201C23.9688 25.4235 23.6601 23.8703 23.08 22.4039ZM12.2746 14.7348C10.8432 14.7348 9.49601 14.1369 8.48251 13.0513C7.46901 11.9657 6.91081 10.5227 6.91081 8.98958C6.91081 7.45642 7.46901 6.01344 8.48251 4.92786C9.49601 3.84229 10.8432 3.24439 12.2746 3.24439C13.7059 3.24439 15.0531 3.84229 16.0666 4.92786C17.0801 6.01344 17.6383 7.45642 17.6383 8.98958C17.6383 10.5227 17.0801 11.9657 16.0666 13.0513C15.0531 14.1369 13.7059 14.7348 12.2746 14.7348Z",
                                            fill: "#1E1E1E",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "user-badge align-items-center",
                                class: _vm.userBadgeBg,
                                on: {
                                  mouseover: function ($event) {
                                    return _vm.handleHideDropDown($event)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "w-100" }, [
                                  _vm.isUserRegistered
                                    ? _c(
                                        "span",
                                        { staticClass: "text-uppercase" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm._f("trans")("FREE"))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isUserPremium
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("trans")("Professional")
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isUserEducational
                                    ? _c(
                                        "span",
                                        { staticClass: "text-uppercase" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm._f("trans")("EDUCATION"))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "bg-white h-100 user-icon" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "24",
                                          height: "28",
                                          viewBox: "0 0 24 28",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M23.08 22.4039C22.4918 20.9114 21.6381 19.5557 20.5666 18.4124C19.4983 17.2657 18.2328 16.3515 16.84 15.7201C16.8275 15.7135 16.815 15.7101 16.8026 15.7034C18.7454 14.2003 20.0083 11.752 20.0083 8.98958C20.0083 4.41347 16.5469 0.705811 12.2746 0.705811C8.00227 0.705811 4.54078 4.41347 4.54078 8.98958C4.54078 11.752 5.80376 14.2003 7.74656 15.7068C7.73408 15.7135 7.72161 15.7168 7.70914 15.7235C6.31207 16.3548 5.05844 17.26 3.98258 18.4157C2.91204 19.56 2.0585 20.9154 1.4691 22.4073C0.890067 23.8678 0.577784 25.4337 0.54915 27.0201C0.548318 27.0558 0.554156 27.0913 0.56632 27.1245C0.578484 27.1577 0.596729 27.1879 0.619978 27.2134C0.643227 27.239 0.671012 27.2592 0.701693 27.2731C0.732375 27.2869 0.765334 27.2941 0.798627 27.294H2.6697C2.80692 27.294 2.91606 27.1771 2.91918 27.0335C2.98155 24.4548 3.94827 22.0399 5.65719 20.2094C7.42536 18.3155 9.77356 17.2734 12.2746 17.2734C14.7756 17.2734 17.1238 18.3155 18.8919 20.2094C20.6009 22.0399 21.5676 24.4548 21.6299 27.0335C21.6331 27.1805 21.7422 27.294 21.8794 27.294H23.7505C23.7838 27.2941 23.8168 27.2869 23.8474 27.2731C23.8781 27.2592 23.9059 27.239 23.9291 27.2134C23.9524 27.1879 23.9706 27.1577 23.9828 27.1245C23.995 27.0913 24.0008 27.0558 24 27.0201C23.9688 25.4235 23.6601 23.8703 23.08 22.4039ZM12.2746 14.7348C10.8432 14.7348 9.49601 14.1369 8.48251 13.0513C7.46901 11.9657 6.91081 10.5227 6.91081 8.98958C6.91081 7.45642 7.46901 6.01344 8.48251 4.92786C9.49601 3.84229 10.8432 3.24439 12.2746 3.24439C13.7059 3.24439 15.0531 3.84229 16.0666 4.92786C17.0801 6.01344 17.6383 7.45642 17.6383 8.98958C17.6383 10.5227 17.0801 11.9657 16.0666 13.0513C15.0531 14.1369 13.7059 14.7348 12.2746 14.7348Z",
                                            fill: "#1E1E1E",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "d-md-flex align-items-center menu-badge mx-2",
                  on: {
                    mouseover: function ($event) {
                      return _vm.handleShowDropDown($event)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "hidden-mobile" }, [
                    _vm._v(_vm._s(_vm._f("trans")("Menu"))),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-bars fg-normal fa-lg" }),
                ]
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "d-flex align-items-center d-md-none" },
            [
              !_vm.isSatAdmin && !_vm.isApi2Convert
                ? [
                    _c(
                      "a",
                      {
                        staticClass:
                          "p-0 m-0 pr-1 h-100 d-flex align-items-center justify-content-center",
                        on: { click: _vm.handleCreditsNav },
                      },
                      [
                        _vm.isImg2Go
                          ? _c(
                              "div",
                              {
                                staticClass: "user-badge",
                                class: _vm.userBadgeBg,
                                on: {
                                  mouseover: function ($event) {
                                    return _vm.handleHideDropDown($event)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "w-100" }, [
                                  _c(
                                    "div",
                                    { staticClass: "user-credits" },
                                    [
                                      _vm._v(_vm._s(this.availableCredit)),
                                      _c("CoinSVG"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.isUserRegistered
                                    ? _c(
                                        "span",
                                        { staticClass: "text-uppercase" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm._f("trans")("FREE"))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isUserPremium
                                    ? _c(
                                        "span",
                                        { staticClass: "text-uppercase" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("trans")(_vm.userProduct)
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isUserEducational
                                    ? _c(
                                        "span",
                                        { staticClass: "text-uppercase" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm._f("trans")("EDUCATION"))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "bg-white h-100 user-icon" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "24",
                                          height: "28",
                                          viewBox: "0 0 24 28",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M23.08 22.4039C22.4918 20.9114 21.6381 19.5557 20.5666 18.4124C19.4983 17.2657 18.2328 16.3515 16.84 15.7201C16.8275 15.7135 16.815 15.7101 16.8026 15.7034C18.7454 14.2003 20.0083 11.752 20.0083 8.98958C20.0083 4.41347 16.5469 0.705811 12.2746 0.705811C8.00227 0.705811 4.54078 4.41347 4.54078 8.98958C4.54078 11.752 5.80376 14.2003 7.74656 15.7068C7.73408 15.7135 7.72161 15.7168 7.70914 15.7235C6.31207 16.3548 5.05844 17.26 3.98258 18.4157C2.91204 19.56 2.0585 20.9154 1.4691 22.4073C0.890067 23.8678 0.577784 25.4337 0.54915 27.0201C0.548318 27.0558 0.554156 27.0913 0.56632 27.1245C0.578484 27.1577 0.596729 27.1879 0.619978 27.2134C0.643227 27.239 0.671012 27.2592 0.701693 27.2731C0.732375 27.2869 0.765334 27.2941 0.798627 27.294H2.6697C2.80692 27.294 2.91606 27.1771 2.91918 27.0335C2.98155 24.4548 3.94827 22.0399 5.65719 20.2094C7.42536 18.3155 9.77356 17.2734 12.2746 17.2734C14.7756 17.2734 17.1238 18.3155 18.8919 20.2094C20.6009 22.0399 21.5676 24.4548 21.6299 27.0335C21.6331 27.1805 21.7422 27.294 21.8794 27.294H23.7505C23.7838 27.2941 23.8168 27.2869 23.8474 27.2731C23.8781 27.2592 23.9059 27.239 23.9291 27.2134C23.9524 27.1879 23.9706 27.1577 23.9828 27.1245C23.995 27.0913 24.0008 27.0558 24 27.0201C23.9688 25.4235 23.6601 23.8703 23.08 22.4039ZM12.2746 14.7348C10.8432 14.7348 9.49601 14.1369 8.48251 13.0513C7.46901 11.9657 6.91081 10.5227 6.91081 8.98958C6.91081 7.45642 7.46901 6.01344 8.48251 4.92786C9.49601 3.84229 10.8432 3.24439 12.2746 3.24439C13.7059 3.24439 15.0531 3.84229 16.0666 4.92786C17.0801 6.01344 17.6383 7.45642 17.6383 8.98958C17.6383 10.5227 17.0801 11.9657 16.0666 13.0513C15.0531 14.1369 13.7059 14.7348 12.2746 14.7348Z",
                                            fill: "#1E1E1E",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isImg2Go
                          ? _c(
                              "div",
                              {
                                staticClass: "user-badge align-items-center",
                                class: _vm.userBadgeBg,
                                on: {
                                  mouseover: function ($event) {
                                    return _vm.handleHideDropDown($event)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "w-100" }, [
                                  _vm.isUserRegistered
                                    ? _c(
                                        "span",
                                        { staticClass: "text-uppercase" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm._f("trans")("FREE"))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isUserPremium
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("trans")("Professional")
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isUserEducational
                                    ? _c(
                                        "span",
                                        { staticClass: "text-uppercase" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm._f("trans")("EDUCATION"))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "bg-white h-100 user-icon" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "24",
                                          height: "28",
                                          viewBox: "0 0 24 28",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M23.08 22.4039C22.4918 20.9114 21.6381 19.5557 20.5666 18.4124C19.4983 17.2657 18.2328 16.3515 16.84 15.7201C16.8275 15.7135 16.815 15.7101 16.8026 15.7034C18.7454 14.2003 20.0083 11.752 20.0083 8.98958C20.0083 4.41347 16.5469 0.705811 12.2746 0.705811C8.00227 0.705811 4.54078 4.41347 4.54078 8.98958C4.54078 11.752 5.80376 14.2003 7.74656 15.7068C7.73408 15.7135 7.72161 15.7168 7.70914 15.7235C6.31207 16.3548 5.05844 17.26 3.98258 18.4157C2.91204 19.56 2.0585 20.9154 1.4691 22.4073C0.890067 23.8678 0.577784 25.4337 0.54915 27.0201C0.548318 27.0558 0.554156 27.0913 0.56632 27.1245C0.578484 27.1577 0.596729 27.1879 0.619978 27.2134C0.643227 27.239 0.671012 27.2592 0.701693 27.2731C0.732375 27.2869 0.765334 27.2941 0.798627 27.294H2.6697C2.80692 27.294 2.91606 27.1771 2.91918 27.0335C2.98155 24.4548 3.94827 22.0399 5.65719 20.2094C7.42536 18.3155 9.77356 17.2734 12.2746 17.2734C14.7756 17.2734 17.1238 18.3155 18.8919 20.2094C20.6009 22.0399 21.5676 24.4548 21.6299 27.0335C21.6331 27.1805 21.7422 27.294 21.8794 27.294H23.7505C23.7838 27.2941 23.8168 27.2869 23.8474 27.2731C23.8781 27.2592 23.9059 27.239 23.9291 27.2134C23.9524 27.1879 23.9706 27.1577 23.9828 27.1245C23.995 27.0913 24.0008 27.0558 24 27.0201C23.9688 25.4235 23.6601 23.8703 23.08 22.4039ZM12.2746 14.7348C10.8432 14.7348 9.49601 14.1369 8.48251 13.0513C7.46901 11.9657 6.91081 10.5227 6.91081 8.98958C6.91081 7.45642 7.46901 6.01344 8.48251 4.92786C9.49601 3.84229 10.8432 3.24439 12.2746 3.24439C13.7059 3.24439 15.0531 3.84229 16.0666 4.92786C17.0801 6.01344 17.6383 7.45642 17.6383 8.98958C17.6383 10.5227 17.0801 11.9657 16.0666 13.0513C15.0531 14.1369 13.7059 14.7348 12.2746 14.7348Z",
                                            fill: "#1E1E1E",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  on: {
                    mouseover: function ($event) {
                      return _vm.handleShowDropDown($event)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "hidden-mobile" }, [
                    _vm._v(_vm._s(_vm._f("trans")("Menu"))),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-bars fg-normal" }),
                ]
              ),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showDropDown
        ? _c(
            "div",
            {
              staticClass:
                "dropdown-menu main-user-dropdown dropdown-menu-right w-100 border bg-white border-top",
              staticStyle: { padding: "20px 10px" },
              attrs: { id: "dropdown-menu-hover" },
              on: {
                mouseover: function ($event) {
                  return _vm.handleShowDropDown($event)
                },
                mouseout: function ($event) {
                  return _vm.handleHideDropDown($event)
                },
              },
            },
            [
              _c(
                "ul",
                { staticClass: "list-unstyled d-flex flex-column gap-20" },
                [
                  !_vm.isSatAdmin
                    ? [
                        _c("div", { staticClass: "d-flex flex-column gap-5" }, [
                          _vm.shouldShowUpgradeBox
                            ? _c(
                                "div",
                                {
                                  staticClass: "card text-white mt-1 br-4",
                                  class: {
                                    "bg-premium-dark":
                                      !_vm.shouldShowEducationalClaim,
                                    "bg-education-i":
                                      _vm.shouldShowEducationalClaim,
                                  },
                                },
                                [
                                  _c("div", { staticClass: "card-body p-3" }, [
                                    _c("p", {
                                      staticClass: "mb-3",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.descriptionUpgradeBox
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-block btn-warning text-dark d-flex align-items-center justify-content-center",
                                        attrs: {
                                          "data-user-button-upgrade": "",
                                          href: "#",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.clickUpgradeButton.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.textUpgradeButton))]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.shouldShowBuyMore
                            ? _c("div", [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-block btn-warning text-dark",
                                    attrs: {
                                      "data-user-button-upgrade": "",
                                      href: "#",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.clickBuyMoreCredits.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "w-100 gap-30 d-flex align-items-center px-4",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-chevron-right",
                                        }),
                                        _vm._v(" "),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("trans")(
                                                "Get more Credits"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showSale
                            ? _c("div", [
                                _vm.isUserRegistered && !_vm.isApi2Convert
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "card premium-bg text-white mt-1",
                                        staticStyle: { "border-radius": "4px" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-body p-3" },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm._f("trans")(
                                                    "Use some of our finest tools for a low cost. Hurry, the offer expires on %sale_end%.",
                                                    {
                                                      "%sale_end%":
                                                        "November 30, 2022",
                                                    }
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "btn btn-block btn-warning text-dark mb-2",
                                                attrs: {
                                                  "data-user-button-upgrade":
                                                    "",
                                                  href: "#",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    $event.preventDefault()
                                                    return _vm.clickUpgradeButton.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.textSaleButton)
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "text-white p-2 text-underline",
                                                staticStyle: {
                                                  color: "#fff !important",
                                                },
                                                attrs: { href: _vm.linkSale },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("trans")(
                                                      "Learn more"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "dropdown-item hidden-in-user-area header-dropdown-item",
                              attrs: { href: _vm.linkRecentTasks },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex gap-20 align-items-center",
                                },
                                [
                                  _c("div", { staticClass: "icon-container" }, [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "28",
                                          height: "30",
                                          viewBox: "0 0 28 30",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M25.0943 13.7864V5.45455C25.0943 4.73123 24.8069 4.03754 24.2955 3.52607C23.784 3.01461 23.0903 2.72727 22.367 2.72727H16.667C16.0943 1.14545 14.5943 0 12.8216 0C11.0488 0 9.54882 1.14545 8.9761 2.72727H3.2761C1.7761 2.72727 0.548828 3.95455 0.548828 5.45455V24.5455C0.548828 25.2688 0.836165 25.9625 1.34763 26.4739C1.85909 26.9854 2.55278 27.2727 3.2761 27.2727H11.6079C13.3261 28.9636 15.6715 30 18.2761 30C23.5534 30 27.8215 25.7318 27.8215 20.4545C27.8215 17.85 26.7852 15.5045 25.0943 13.7864ZM12.8216 2.72727C13.5715 2.72727 14.1852 3.34091 14.1852 4.09091C14.1852 4.84091 13.5715 5.45455 12.8216 5.45455C12.0716 5.45455 11.4579 4.84091 11.4579 4.09091C11.4579 3.34091 12.0716 2.72727 12.8216 2.72727ZM3.2761 24.5455V5.45455H6.00337V8.18182H19.6397V5.45455H22.367V11.8364C20.5883 10.9913 18.5916 10.7174 16.6511 11.0524C14.7105 11.3873 12.9212 12.3147 11.5287 13.7072C10.1362 15.0996 9.20888 16.889 8.87392 18.8295C8.53896 20.7701 8.81282 22.7668 9.65792 24.5455H3.2761ZM18.2761 27.2727C14.5125 27.2727 11.4579 24.2182 11.4579 20.4545C11.4579 16.6909 14.5125 13.6364 18.2761 13.6364C22.0397 13.6364 25.0943 16.6909 25.0943 20.4545C25.0943 24.2182 22.0397 27.2727 18.2761 27.2727ZM18.9579 20.7955L22.8579 23.1L21.8352 24.7636L16.9125 21.8182V15H18.9579V20.7955Z",
                                            fill: "currentColor",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm._f("trans")("Recent Tasks"))
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-flex flex-column gap-5" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm._f("trans")("Account"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "dropdown-item hidden-in-user-area header-dropdown-item",
                              attrs: { href: _vm.linkDashboard },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex gap-20 align-items-center",
                                },
                                [
                                  _c("div", { staticClass: "icon-container" }, [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "24",
                                          height: "28",
                                          viewBox: "0 0 24 28",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M23.08 22.4039C22.4918 20.9114 21.6381 19.5557 20.5666 18.4124C19.4983 17.2657 18.2328 16.3515 16.84 15.7201C16.8275 15.7135 16.815 15.7101 16.8026 15.7034C18.7454 14.2003 20.0083 11.752 20.0083 8.98958C20.0083 4.41347 16.5469 0.705811 12.2746 0.705811C8.00227 0.705811 4.54078 4.41347 4.54078 8.98958C4.54078 11.752 5.80376 14.2003 7.74656 15.7068C7.73408 15.7135 7.72161 15.7168 7.70914 15.7235C6.31207 16.3548 5.05844 17.26 3.98258 18.4157C2.91204 19.56 2.0585 20.9154 1.4691 22.4073C0.890067 23.8678 0.577784 25.4337 0.54915 27.0201C0.548318 27.0558 0.554156 27.0913 0.56632 27.1245C0.578484 27.1577 0.596729 27.1879 0.619978 27.2134C0.643227 27.239 0.671012 27.2592 0.701693 27.2731C0.732375 27.2869 0.765334 27.2941 0.798627 27.294H2.6697C2.80692 27.294 2.91606 27.1771 2.91918 27.0335C2.98155 24.4548 3.94827 22.0399 5.65719 20.2094C7.42536 18.3155 9.77356 17.2734 12.2746 17.2734C14.7756 17.2734 17.1238 18.3155 18.8919 20.2094C20.6009 22.0399 21.5676 24.4548 21.6299 27.0335C21.6331 27.1805 21.7422 27.294 21.8794 27.294H23.7505C23.7838 27.2941 23.8168 27.2869 23.8474 27.2731C23.8781 27.2592 23.9059 27.239 23.9291 27.2134C23.9524 27.1879 23.9706 27.1577 23.9828 27.1245C23.995 27.0913 24.0008 27.0558 24 27.0201C23.9688 25.4235 23.6601 23.8703 23.08 22.4039ZM12.2746 14.7348C10.8432 14.7348 9.49601 14.1369 8.48251 13.0513C7.46901 11.9657 6.91081 10.5227 6.91081 8.98958C6.91081 7.45642 7.46901 6.01344 8.48251 4.92786C9.49601 3.84229 10.8432 3.24439 12.2746 3.24439C13.7059 3.24439 15.0531 3.84229 16.0666 4.92786C17.0801 6.01344 17.6383 7.45642 17.6383 8.98958C17.6383 10.5227 17.0801 11.9657 16.0666 13.0513C15.0531 14.1369 13.7059 14.7348 12.2746 14.7348Z",
                                            fill: "currentColor",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm._f("trans")("Dashboard"))
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item header-dropdown-item",
                              attrs: { href: _vm.linkSocial },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex gap-20 align-items-center",
                                },
                                [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm._f("trans")("Linked Accounts"))
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "dropdown-item hover-danger logout-btn",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.logoutUser.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex gap-20 align-items-center",
                                },
                                [
                                  _c("div", { staticClass: "icon-container" }, [
                                    _c("i", {
                                      class: {
                                        "far fa-sign-out": !_vm.isLoggingOut,
                                        "fa fa-spinner fa-spin":
                                          _vm.isLoggingOut,
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(_vm._s(_vm._f("trans")("Logout"))),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.isApi2Convert === true
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-lg-none pl-0 api2convert-items d-flex flex-column gap-5",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dropdown-item header-dropdown-item",
                                    attrs: { href: _vm.linkDocumentation },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex gap-20 align-items-center",
                                      },
                                      [
                                        _vm._m(1),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("trans")("Documentation")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dropdown-item header-dropdown-item",
                                    attrs: { href: _vm.linkFileFormats },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex gap-20 align-items-center",
                                      },
                                      [
                                        _vm._m(2),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("trans")("File Formats")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dropdown-item header-dropdown-item",
                                    attrs: { href: _vm.linkBlog },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex gap-20 align-items-center",
                                      },
                                      [
                                        _vm._m(3),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(_vm._f("trans")("Blog"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "pl-0 hidden-in-user-area d-flex flex-column gap-5",
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm._f("trans")("Billing"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "dropdown-item header-dropdown-item",
                                attrs: { href: _vm.linkInvoices },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex gap-20 align-items-center",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "icon-container" },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "18",
                                              height: "20",
                                              viewBox: "0 0 18 20",
                                              fill: "none",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M0 0V18H11.0769V16.6154H1.38462V1.38462H8.30769V5.53846H12.4615V6.92308H13.8462V4.56923L13.6385 4.36154L9.48462 0.207692L9.27692 0H0ZM9.69231 2.35385L11.4923 4.15385H9.69231V2.35385ZM2.76923 6.92308V8.30769H11.0769V6.92308H2.76923ZM14.5385 8.30769V9.69231C13.3615 9.9 12.4615 10.8692 12.4615 12.1154C12.4615 13.5 13.5 14.5385 14.8846 14.5385H15.5769C16.1308 14.5385 16.6154 15.0231 16.6154 15.5769C16.6154 16.1308 16.1308 16.6154 15.5769 16.6154H13.1538V18H14.5385V19.3846H15.9231V18C17.1 17.7923 18 16.8231 18 15.5769C18 14.1923 16.9615 13.1538 15.5769 13.1538H14.8846C14.3308 13.1538 13.8462 12.6692 13.8462 12.1154C13.8462 11.5615 14.3308 11.0769 14.8846 11.0769H17.3077V9.69231H15.9231V8.30769H14.5385ZM2.76923 10.3846V11.7692H7.61539V10.3846H2.76923ZM9 10.3846V11.7692H11.0769V10.3846H9ZM2.76923 13.1538V14.5385H7.61539V13.1538H2.76923ZM9 13.1538V14.5385H11.0769V13.1538H9Z",
                                                fill: "currentColor",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(_vm._f("trans")("Invoices"))
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isApi2Convert
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.clickUpgradeButton.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex gap-20 align-items-center",
                                      },
                                      [
                                        _vm._m(4),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("trans")("Buy Credits")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "d-flex flex-column gap-20",
                          attrs: { id: "user-nav-top" },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "fa fa-link" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "far fad fa-book" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "far fa fa-file-alt" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "far fa-blog" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "far fa-shopping-cart" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }